import Image from "next/image"



export default function roadmap ()  {
  return (
    <div className="w-full">
     <Image
      src="/images/roadmap.png"
      alt="Picture of the author"
      width={1500}
      height={860}
    />
    </div>
  )
}
